/**
 * Format a number to at most 2 decimal places, dropping trailing zeros.
 *
 * Examples:
 *   formatNumber(100)     → "100"
 *   formatNumber(10.5)    → "10.5"
 *   formatNumber(10.123)  → "10.12"
 *   formatNumber(0.1)     → "0.1"
 *   formatNumber(-3.14)   → "-3.14"
 */
export function formatNumber(n: number): string {
  if (!Number.isFinite(n)) return "0";
  if (Number.isInteger(n)) return String(n);
  return Number(n.toFixed(2)).toString();
}
